import React from 'react';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import '../assets/css/components/breadcrumbs.css';

// Accepts a list of objects where each object has a required `text` and optional `link` key.
// The breadcrumbs are constructed from left-to-right in the order that they were provided.
const Breadcrumbs = ({ items }) => {
  const renderListItem = (itemContents, key) => <li key={key} className="breadcrumb-item link">{itemContents}</li>

  const renderItem = (item, key) =>
    !!item.link ? (
      renderListItem(<Link to={item.link}>{item.text}</Link>, key)
    ) : (
      renderListItem(item.text, key)
    )

  const renderItems = ()=> _.map(items, (item, index) => renderItem(item, index))

  return(
    <div className='no-print breadcrumb-container'>
      <ol className="breadcrumb">
        {renderItems()}
      </ol>
    </div>
  );
}

export default Breadcrumbs;
